/** Flags CHAR S/N de WXRL (NegCond, Visible, ExitCond) vienen de BD rellenos (#765). */

export function isSnFlagSet(value: unknown): boolean {
  return String(value ?? '').trim().toUpperCase().charAt(0) === 'S';
}

export function normalizeSnFlag(value: unknown, defaultValue: 'S' | 'N' = 'N'): 'S' | 'N' {
  if (value === true) return 'S';
  if (value === false || value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return isSnFlagSet(value) ? 'S' : 'N';
}

/** RULESCONDITION.Visible admite S, N o vacío (no aplica) (#768). */
export function normalizeVisibleFlag(value: unknown, defaultValue: 'S' | 'N' | '' = 'S'): 'S' | 'N' | '' {
  if (value === true) return 'S';
  if (value === false) return 'N';
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (String(value).trim() === '') return '';
  return isSnFlagSet(value) ? 'S' : 'N';
}
